import type { State } from 'state';

export const getShouldOpenFeedbackWidget = (state: State): boolean => {
    return state.ui.feedbackCollector.shouldOpenFeedbackWidget;
};

export const getShowTypeField = (state: State): boolean => {
    return state.ui.feedbackCollector.showTypeField;
};

export const getAdditionalFields = (state: State): Record<string, string | object> => {
    return state.ui.feedbackCollector.additionalFields;
};

export const getCustomComponent = (
    state: State
):
    | React.ComponentClass<{
          onChange: (fieldId: string, fieldValue: string | object) => void;
          additionalFields: Record<string, string | object>;
      }>
    | undefined => {
    return state.ui.feedbackCollector.CustomComponent;
};
